import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate, Trans } from "react-i18next";

import Button from "components/Button";
import Loader, { LoaderStyle } from "components/Loader";

import style from "./style.css";

@translate()
export default class UpdateIp extends Component {
  render() {
    const { isLoading, onClick, isDisabled, newIpPolicy } = this.props;
    return (
      <div>
        <Button
          type="button"
          onClick={onClick.bind(this)}
          isDisabled={isDisabled}>
          {isLoading && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
          {!isLoading && <Trans>_cgn_form_component_update_ip_label_button</Trans>}
        </Button>
        {newIpPolicy.success === true && (
          <p className={style.errorSuccess}>
            <Trans>{newIpPolicy.message}</Trans>
          </p>
        )}
        {newIpPolicy.success === false && (
          <p className={style.errorMessage}>
            <Trans>{newIpPolicy.message}</Trans>
          </p>
        )}
      </div>
    );
  }
}

UpdateIp.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  rootClassname: PropTypes.string,
  newIpPolicy: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Cgn/UpdateIp/index.js